<template>
  <div>
    <div class="text-xs-right">
      <!-- <exportxlsx2 filename="top-store" @onExport="onExport"></exportxlsx2> -->

      <v-btn @click="showGroupDownload = true" color="grey" outline>
        <em class="fas fa-file-export" />
        &nbsp;
        {{ $t('export') }}&nbsp;
      </v-btn>
      <v-layout>
        <v-flex></v-flex>
        <v-flex shrink style="white-space: nowrap">
          <v-text-field
            class="default-input"
            name="name"
            single-line
            v-model="search.name"
            id="name"
            outline
            prepend-inner-icon="search"
            clearable
            style="max-width: 300px"
            placeholder="ค้นหาชื่อร้านค้า"
            hide-details
            @blur="onSearch"
            @keyup.enter="onSearch"
            :loading="loading"
          ></v-text-field>
        </v-flex>
        <!-- <v-flex shrink>
          <v-btn color="primary" @click="onSearch" :loading="loading">{{ $t('Search') }} </v-btn>
        </v-flex> -->
      </v-layout>
    </div>

    <Pagination
      v-model="page"
      :limit="limit"
      :total="total"
      :key="'top_pagination_' + timestamp"
      @onChange="onChange($event)"
    ></Pagination>
    <v-data-table
      :headers="headers"
      :pagination.sync="pagination"
      :items="data"
      class="elevation-1"
      hide-actions
      :loading="loading"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.total }}</td>
          <td class="text-xs-center">{{ props.item.total_receipt }}</td>
          <td>
            <v-btn
              color="primary"
              small
              @click="
                store = props.item
                showHistory = true
              "
            >
              ประวัติการซื้อ
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <Pagination
      v-model="page"
      :limit="limit"
      :total="total"
      :key="'bottom_pagination_' + timestamp"
      @onChange="onChange($event)"
    ></Pagination>

    <v-dialog v-model="showHistory">
      <template v-if="store">
        <StoreHistory
          v-model="store"
          @onClose="
            showHistory = false
            store = null
          "
        ></StoreHistory>
      </template>
    </v-dialog>

    <ExportGroup
      v-model="showGroupDownload"
      @onExport="onExport"
      :total="total"
      filename="top_store"
    ></ExportGroup>
  </div>
</template>

<script>
import Pagination from '@/components/elements/Pagination.vue'
import moment from 'moment'
import StoreHistory from './StoreHistory'
import exportxlsx2 from '@/components/elements/Exportxlsx2.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import ExportGroup from '@/components/elements/ExportGroup.vue'
export default {
  data() {
    return {
      store: null,
      showHistory: false,
      timestamp: moment().format('x'),
      headers: [
        {
          sortable: false,
          text: 'ลำดับ'
        },
        {
          value: 'name',
          text: 'ชื่อร้านค้า'
        },
        {
          value: 'total',
          text: 'ยอดซื้อรวมของร้านค้า',
          align: 'center'
        },
        {
          value: 'total_receipt',
          text: 'จำนวนใบเสร็จ',
          align: 'center'
        },
        {
          sortable: false
        }
      ],
      data: [],
      total: 0,
      pagination: {
        rowsPerPage: -1,
        sortBy: 'total_receipt',
        descending: true
      },
      search: {
        name: ''
      },
      limit: 25,
      offset: 0,
      page: 1,
      alldata: [],
      loading: true,
      showGroupDownload: false
    }
  },
  components: {
    Pagination,
    StoreHistory,
    exportxlsx2,
    ExportGroup
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  async mounted() {},
  methods: {
    async onSearch() {
      if (this.loading) return false
      this.loading = true
      let { data, total } = await this.getTopStore(this.limit, 0)
      this.total = total
      this.data = data
      this.page = 1
      this.timestamp = moment().format('x')
      this.loading = false
    },
    async onExport(callback) {
      if (callback) {
        this.loading = true
        let { limit, offset } = callback
        let { data } = await this.getTopStore(limit, offset)
        let format_data = data.map((el) => {
          return {
            รหัสร้านค้า: el.store_id,
            ชื่อร้านค้า: el.name,
            ยอดซื้อรวมของร้านค้า: el.total,
            จำนวนใบเสร็จ: el.total_receipt
          }
        })
        callback.submitData(format_data)
        this.loading = false
      }
    },
    async getTopStore(limit, offset) {
      const { sortBy, descending } = this.pagination

      let response = await api.getTopStore({
        pageid: this.selectedBot.pageid,
        campaignid: this.selectedCampaign ? this.selectedCampaign.id : null,
        limit: limit,
        offset: offset,
        sortBy: sortBy,
        descending: descending,
        ...this.search
      })

      return {
        total: response ? response.total : 0,
        data: response ? response.data : []
      }
    },
    async onChange(val) {
      this.loading = true
      let { data, total } = await this.getTopStore(val.limit, val.offset)
      this.total = total
      this.data = data
      this.loading = false
    }
  },
  watch: {
    async pagination() {
      this.loading = true
      let { data, total } = await this.getTopStore(this.limit, 0)
      this.total = total
      this.data = data
      this.page = 1
      this.timestamp = moment().format('x')
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/TopStore.vue